import { fetchProgrammes } from "../../clients/programmes"
import { fromStrapiProgramme } from "../../helpers/mapping/programme"
import { Programme } from "../../types"
import { MembershipType } from "../../types/MembershipType"

class ProgrammeRepository {

    async retrieveAllProgrammes(membershipType: MembershipType): Promise<Programme[]> {
        const { data } = await fetchProgrammes(membershipType)
        return data.map((i: unknown) => fromStrapiProgramme(i))
    }
}

export default ProgrammeRepository